import classNames from 'classnames';
import { MaterialSymbols } from 'material-design-icons-literal-types';

type ITagProps = React.ComponentPropsWithoutRef<'i'>;
export interface SharedIconProps extends ITagProps {
  iconName: MaterialSymbols;
  bold?: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark';
  classes?: string;
}

export const SharedIcon = ({
  iconName,
  bold = false,
  size = 'md',
  color,
  classes = '',
  ...rest
}: SharedIconProps) => (
  <i
    {...rest}
    className={classNames(
      'material-symbols-outlined',
      classes,
      color && 'text-' + color,
      {
        'fw-bold': bold,
        'fs-6': size === 'sm',
        'fs-5': size === 'md',
        'fs-3': size === 'lg',
      }
    )}
  >
    {iconName}
  </i>
);
